module.exports = __webpack_public_path__ + "assets/advantages-navigate-6481b5.svg";